import React from 'react';
import PropTypes from 'prop-types';
import styled, {
  css,
} from 'styled-components';
import { Glyphicon } from 'react-bootstrap';
import Pagination from './Pagination';

const baseBtnStyles = css`
  z-index: 100;
  position: absolute;
  top: 50%;
`;

const StyledGlyph = styled(Glyphicon)`
  color: #fff;
  cursor: pointer;
  text-shadow: 0 1px 2px rgba(0,0,0,.6);
  font-size: 20px;
  @media screen and (min-width: 768px) {
    font-size: 30px;
  }
  opacity: .6;

  transition: 0.2s;
  :hover {
    opacity: 1;
  }
`;

const LeftBtn = styled.div`
  ${baseBtnStyles}
  left: 20px;
  float: left;
`;

const RightBtn = styled.div`
  ${baseBtnStyles}
  right: 20px;
  float: right;
`;

function CarouselControl({ length, onPrev, onNext, onPagination, activeItem }) {
  return (
    <div>
      <LeftBtn onClick={onPrev}>
        <StyledGlyph glyph="chevron-left" />
      </LeftBtn>
      <RightBtn onClick={onNext}>
        <StyledGlyph glyph="chevron-right" />
      </RightBtn>
      <Pagination length={length} onClick={onPagination} activeItem={activeItem} />
    </div>
  );
}

Pagination.propTypes = {
  activeItem: PropTypes.number,
};

Pagination.defaultProps = {
  activeItem: 0,
};

export default CarouselControl;



// WEBPACK FOOTER //
// ./src/components/landing/FeatureCarousel/CarouselControl/index.js